import { render, staticRenderFns } from "./suggest-search.vue?vue&type=template&id=2b6ee960&"
import script from "./suggest-search.vue?vue&type=script&lang=js&"
export * from "./suggest-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports